import { AxiosError } from "axios";

import { Endpoints } from "@sso/apis/endpoints";
import { notificationsMsgs } from "@sso/constant";
import { ApiErrors } from "@sso/types";

type errorResponse = { msg: string; isUnAuthorized: boolean, isWarning:boolean };

export const errorHandling = (error: AxiosError<ApiErrors>, url?: string): errorResponse => {
  const response = { msg: "", isUnAuthorized: false, isWarning: false };
  if (error.response) {
    if (error.response.status === 401) {
      response.msg = url === Endpoints.LOGIN ? notificationsMsgs.WRONG_CREDENTIALS : notificationsMsgs.EXPIRE_SESSION;
      response.isUnAuthorized = true;
      return response;
    }
   if (error.response.status === 400)
   {
    response.msg = error.response.data.message;
    response.isWarning = true;
    return response;
   }
    response.msg = error.response.data.message || notificationsMsgs.DEFAULT_ERROR;
  } else {
    response.msg = error.message;
  }
  return response;
};
